import { Modal } from 'antd';
import parser from 'html-react-parser';
import React, { ReactNode } from 'react';
import { GrFormClose } from 'react-icons/gr';

type Props = {
    open: boolean;
    setOpen: (t: boolean) => void;
    text: string;
    icon?: ReactNode;
    Action?: ReactNode;
};

const InfoPOP: React.FC<Props> = ({ open, setOpen, text, icon, Action }) => {
    const onClickClose = () => {
        setOpen(false);
    };

    return (
        <Modal
            centered={true}
            width={450}
            open={open}
            onCancel={onClickClose}
            footer={null}
            className="infoPOP"
            closeIcon={<GrFormClose fontSize={'1.5rem'} color="#404040" />}
        >
            <div className="pl-4">{icon}</div>
            <div className="flex justify-center items-center m-4">
                <div className="text-sm text-[#20222B] WorkSans text-justify">{parser(text)}</div>
            </div>
            {Action && <div className="p-2 flex justify-center items-center">{Action}</div>}
        </Modal>
    );
};

export default InfoPOP;
